import React, { useState } from 'react';
import ModalWithAction from 'app/shared/components/common/modal/modal-with-Action';
import { useHistory } from 'react-router';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import { IconButton } from '@material-ui/core';
import { getModalInformationButton } from 'app/modules/cms/service/store/selectors';
import { useSelector } from 'react-redux';

export default function PrimarySearchAppBar({ router, cmsNavBar }) {
  const [openModal, setOpenModal] = useState(false);
  const history = useHistory();
  const modalInformation: any = useSelector(getModalInformationButton)

  return (
    <>
      <div className="disconnect">
                <IconButton
                    className="disconnect-icon"
                    aria-label="account of current user"
                    aria-controls="primary-search-account-menu"
                    aria-haspopup="true"
                    onClick={()=> {setOpenModal(true)}}
                    color="inherit"
                >
                    <PowerSettingsNewIcon></PowerSettingsNewIcon>
                </IconButton>
            </div>
      <ModalWithAction
        showModal={openModal}
        setShowModel={setOpenModal}
        textBody="Voulez-vous vraiment vous déconnecter ?"
        action={() => {
          setOpenModal(false);
          history.push('/logout');
        }}
        btnActionLabel={modalInformation?.CONFIRMED_button}
        btnCloseLabel={modalInformation?.CANCEL_button}
      />
    </>
  );
}
